import React, { useMemo } from 'react';
import { Row, Col, Bubble } from 'tea-component';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import CardCommon from '@/pages/opinion/components/CardCommon';
import useDealwithPlatform from '../hooks/useDealwithPlatform';
import { useIntl } from 'umi';
import { formatSimpleTimeFunc } from '@/pages/opinion/utils/time';
import { useRequestLifetimePcConsole } from '../hooks/useRequestLifetimePcConsole';
import useConsoleDevices from '@/pages/opinion/hooks/useConsoleDevices';

export default function GameStoreConsole({
  gameInfo,
  filter,
  handleTitleOnClick,
}: any) {
  const { formatMessage } = useIntl();

  const { tabOptions, deviceLoading, value, setValue } = useConsoleDevices({
    gameInfo,
  });

  const params = useMemo(() => {
    if (value) {
      const { channel, ...otherFilter } = filter;
      return {
        ...otherFilter,
        ...gameInfo,
        channels: ['opencritic', 'metacritic'],
        device: value,
      };
    }

    return {};
  }, [value, filter]);

  const {
    changeTime,
    loading,
    data: consoleData,
    show,
    time,
    isToday,
  } = useRequestLifetimePcConsole({
    filter: params,
  });

  const { metacriticElement, opencriticElement } = useDealwithPlatform({
    data: consoleData,
    show: show,
    setTime: changeTime,
    loading: loading,
    isToday: isToday,
  });

  return (
    <Row className="dbo-cardrow-wrap">
      <Col>
        <CardCommon
          className="dbo-gamestorecard dbo-gamestorecard--console"
          title={formatMessage({ id: 'Game Store' })}
          loading={deviceLoading || loading}
          filters={tabOptions}
          filterInfo={[value, setValue]}
          handleFilterOnChange={(value) => {
            setValue(value);
          }}
          filterClassName="gamestore-console-segment"
          loadingHeight={174}
          hasTitleArrow={handleTitleOnClick}
          handleTitleOnClick={() => handleTitleOnClick?.()}
        >
          <>
            <div className="gamestore-console-context">
              <div className="context-item">
                <div className="context-item-title">
                  <ChannelLabel
                    channel_name={'opencritic'}
                    showText={false}
                    style={{ marginRight: 10 }}
                  ></ChannelLabel>
                  <span className="context-item-title-text">OpenCritic</span>
                </div>

                <div className="context-item-flex">
                  <Bubble content={undefined} dark closeOnScroll>
                    <div className="context-item-flex-title">
                      {formatMessage({ id: 'Lifetime Reviews' })}
                    </div>
                  </Bubble>
                  <div className="context-item-flex-time">
                    {time.opencritic &&
                      formatMessage({ id: 'Up to' }) +
                        ' ' +
                        formatSimpleTimeFunc(time.opencritic)}
                  </div>
                </div>
                <div className="context-item-progress-flex">
                  {opencriticElement}
                </div>
              </div>
              <div className="context-item">
                <div className="context-item-title">
                  <ChannelLabel
                    channel_name={'metacritic'}
                    showText={false}
                    style={{ marginRight: 10 }}
                  ></ChannelLabel>
                  <span className="context-item-title-text">MetaCritic</span>
                </div>

                <div className="context-item-flex">
                  <Bubble content={null} dark closeOnScroll>
                    <div className="context-item-flex-title">
                      {formatMessage({ id: 'Lifetime Reviews' })}
                    </div>
                  </Bubble>
                  <div className="context-item-flex-time">
                    {time.metacritic &&
                      formatMessage({ id: 'Up to' }) +
                        ' ' +
                        formatSimpleTimeFunc(time.metacritic)}
                  </div>
                </div>
                <div className="context-item-progress-flex">
                  {metacriticElement}
                </div>
              </div>
            </div>
          </>
        </CardCommon>
      </Col>
    </Row>
  );
}
